<div class="edit-profile">
  <div class="title flex" (click)="onBack()" *ngIf="!isDesktop">
    <img src="assets/images/icons/left-arrow.svg" alt="Arrow Left Icon" />
    <p>Wallet</p>
  </div>
  <div class="wallet-balance">
    <div class="flex">
      <div class="remaining flex">
        <img src="assets/images/icons/wallet-gray.svg" alt="Wallet Icon" />
        <span>Your Balance</span>
      </div>
      <div class="pay-button">
        <button
          class="button outline-button"
          (click)="onChargeWallet()"
        >
          <img src="assets/images/icons/plus-blue.svg" alt="" />
          Top Up
        </button>
      </div>
    </div>
    <p class="remaining-amount flex">
      <span>{{ storeDetail?.currency_detail?.symbol }}</span>
      <span>{{ remaining }}</span>
    </p>
  </div>
  <no-result [isWalletPage]="true" *ngIf="isListEmpty"></no-result>
  <div class="page-title" *ngIf="!isListEmpty">
    <p>Transaction List:</p>
    <button
      type="button"
      class="button warn-button"
    >
      <img src="assets/images/icons/filter.svg" alt="" /> <span>Filter</span>
    </button>
  </div>
  <div class="profile-item" *ngIf="!isListEmpty">
    <div class="transactions">
      <div *ngIf="!isDesktop">
        <ng-container *ngFor="let transaction of transactions; let i = index">
          <div class="transaction-item" *ngIf="transaction?.status_code != 50">
            <div class="flex">
              <div class="product-detail flex">
                <img
                  src="assets/images/icons/transaction_{{
                    transaction.status_code
                  }}.svg"
                  alt=""
                />
                <span>{{
                  transaction?.extra_data?.order_detail?.product_detail?.name
                }}</span>
              </div>
              <p
                class="status"
                [ngClass]="{
                  'charge-status': transaction?.status_code == 51,
                  'purchase-status': transaction?.status_code == 52,
                  'refund-status': transaction?.status_code == 53
                }"
              >
                {{ transaction.status }}
              </p>
            </div>
            <div class="flex amount-detail">
              <p class="transaction-title">Amount</p>
              <p class="transaction-amount">
                {{ transaction.currency_detail.symbol }}{{ transaction.amount }}
              </p>
            </div>
            <div class="flex">
              <p class="transaction-title">Order ID</p>
              <p class="transaction-amount">
                {{
                  transaction?.extra_data?.order_detail?.order_code
                    ? transaction?.extra_data?.order_detail?.order_code
                    : "-"
                }}
              </p>
            </div>
            <div class="flex">
              <p class="transaction-title">Date</p>
              <p class="transaction-amount">
                {{ transaction.transaction_date | date : "yyyy.M.d h:mm a" }}
              </p>
            </div>
            <hr class="custom-hr" *ngIf="i != transactions?.length - 1" />
          </div>
        </ng-container>
      </div>
      <table
        mat-table
        [dataSource]="transactions"
        class="transaction-list-table w-full"
        *ngIf="isDesktop"
      >
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let element">
            <div class="flex amount-td product-detail">
              <img
                *ngIf="element?.status_code"
                src="assets/images/icons/transaction_{{
                  element.status_code
                }}.svg"
                alt=""
              />
              <span>{{
                element?.extra_data?.order_detail?.product_detail?.name
              }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let element">
            <p class="flex amount-td">
              <span>{{ element?.currency_detail?.symbol }}</span>
              <span>{{ element?.amount | number }}</span>
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="transaction_id">
          <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
          <td mat-cell *matCellDef="let element">
                {{element?.transaction_id}}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">
            <span
              [ngClass]="{
                'charge-status': element?.status_code == 51,
                'purchase-status': element?.status_code == 52,
                'refund-status': element?.status_code == 53
              }"
            >
              {{ element?.status }}</span
            >
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.transaction_date | date : "yyyy.M.dd" }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>

<ng-template #transactionDetail>
  <div *ngIf="notFound" class="not-found">
    {{ "wallet.hasnoDetail" | translate }}
  </div>
  <div *ngIf="!notFound && result">
    <table class="detail" *ngIf="isCharge">
      <tr>
        <th>{{ "wallet.GatewayImage" | translate }}</th>
        <td><img class="detail-img" [src]="result?.gateway_detail?.logo" /></td>
      </tr>
      <tr>
        <th>{{ "wallet.GatewayName" | translate }}</th>
        <td>{{ result?.gateway_detail?.title || "-" }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.transactionType" | translate }}</th>
        <td>{{ "wallet.topup" | translate }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.Amount" | translate }}</th>
        <td>
          {{ result?.gateway_detail?.currency_detail?.symbol
          }}{{ result?.payment_detail.amount }}
        </td>
      </tr>
    </table>
    <table class="detail" *ngIf="isPurchase">
      <tr>
        <th>{{ "wallet.ProductImage" | translate }}</th>
        <td *ngIf="result?.product_detail">
          <img class="detail-img" [src]="result?.product_detail?.logo" />
        </td>
        <td *ngIf="result?.crypto_product_detail">
          <img
            class="detail-img"
            [src]="result?.crypto_product_detail?.avatar"
          />
        </td>
      </tr>
      <tr>
        <th>{{ "wallet.ProductName" | translate }}</th>
        <td *ngIf="result?.product_detail">
          {{ result?.product_detail?.name || "-" }}
          {{ result?.product_detail?.currency_detail.symbol
          }}{{ result?.item_price }}
        </td>

        <td *ngIf="result?.crypto_product_detail">
          {{ result?.crypto_product_detail?.title || "-" }}
          {{ result?.currency_detail.symbol }}{{ result?.item_price }}
        </td>
      </tr>
      <tr>
        <th>{{ "wallet.ItemCount" | translate }}</th>
        <td>{{ result?.item_count || "-" }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.orderId" | translate }}</th>
        <td>{{ result?.order_code || "-" }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.transactionType" | translate }}</th>
        <td>{{ "wallet.Purchase" | translate }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.discountPercent" | translate }}</th>
        <td>{{ result?.discount | convertPrice }}%</td>
      </tr>
      <tr>
        <th>{{ "wallet.cashbackPercent" | translate }}</th>
        <td>{{ result?.cashback | convertPrice }}%</td>
      </tr>
      <tr>
        <th>{{ "wallet.paymentAmount" | translate }}</th>
        <td *ngIf="!result?.gateway_detail">
          {{ storeDetail?.currency_detail?.symbol }}{{ result?.payable_amount }}
        </td>
        <td *ngIf="result?.gateway_detail">
          {{ result?.gateway_detail?.currency_detail?.symbol
          }}{{ result?.payable_amount }}
        </td>
      </tr>
      <tr *ngIf="result?.phone">
        <th>{{ "wallet.Phone" | translate }}</th>
        <td>+{{ result?.phone || "-" }}</td>
      </tr>
      <tr *ngIf="result?.email">
        <th>{{ "wallet.Email" | translate }}</th>
        <td>{{ result?.email || "-" }}</td>
      </tr>
      <tr *ngIf="result?.whatsapp">
        <th>{{ "wallet.Whatsapp" | translate }}</th>
        <td>{{ result?.whatsapp || "-" }}</td>
      </tr>
    </table>
    <table class="detail" *ngIf="isCashback || isRefund">
      <tr>
        <th>{{ "wallet.ProductImage" | translate }}</th>
        <td *ngIf="result?.product_detail">
          <img class="detail-img" [src]="result?.product_detail?.logo" />
        </td>
        <td *ngIf="result?.crypto_product_detail">
          <img
            class="detail-img"
            [src]="result?.crypto_product_detail?.avatar"
          />
        </td>
      </tr>
      <tr>
        <th>{{ "wallet.ProductName" | translate }}</th>
        <td *ngIf="result?.product_detail">
          {{ result?.product_detail?.name || "-" }}
          {{ result?.product_detail?.currency_detail.symbol
          }}{{ result?.item_price }}
        </td>
        <td *ngIf="result?.crypto_product_detail">
          {{ result?.crypto_product_detail?.title || "-" }}
          {{ result?.currency_detail.symbol }}{{ result?.item_price }}
        </td>
      </tr>
      <tr>
        <th>{{ "wallet.ItemCount" | translate }}</th>
        <td>{{ result?.item_count || "-" }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.orderId" | translate }}</th>
        <td>{{ result?.order_code || "-" }}</td>
      </tr>
      <tr>
        <th>{{ "wallet.transactionType" | translate }}</th>
        <td *ngIf="isCashback">{{ "wallet.cashback" | translate }}</td>
        <td *ngIf="isRefund">{{ "wallet.refund" | translate }}</td>
      </tr>
      <tr *ngIf="isCashback">
        <th>{{ "wallet.cashbackPercent" | translate }}</th>
        <td>{{ result?.cashback | convertPrice }}%</td>
      </tr>
      <tr>
        <th>{{ "wallet.paymentAmount" | translate }}</th>
        <td *ngIf="!result?.gateway_detail">
          {{ storeDetail?.currency_detail?.symbol }}{{ result?.payable_amount }}
        </td>
        <td *ngIf="result?.gateway_detail">
          {{ result?.gateway_detail?.currency_detail?.symbol
          }}{{ result?.payable_amount }}
        </td>
      </tr>
    </table>
  </div>
</ng-template>
